import Benefits from "../../components/benefits";

export default Benefits;